import { useIntl } from 'react-intl';
import { DEFAULT_PAGINATION } from 'constants/common';
import { FilterForm } from 'components/form';
import {
  StyledSpace,
  StyledFormItem,
  StyledInputSearch,
} from 'styles/overrides';
import { normalizeSearchData, normalizeSubmitSearchData } from 'utils/common';
import LocalesSelector from 'components/selectors/Locales';
import UserSelector from 'components/selectors/CategorySelector';

export const ProductFilterSearchForm = ({ onSubmit, initialValues }) => {
  const intl = useIntl();

  const handleSubmit = (values) => {
    onSubmit(
      normalizeSubmitSearchData({
        ...initialValues,
        ...values,
        page: DEFAULT_PAGINATION.PAGE,
      }),
    );
  };

  return (
    <FilterForm
      onFinish={handleSubmit}
      initialValues={{
        ...normalizeSearchData(initialValues),
        shopId: Number(initialValues.shopId) || null,
      }}
    >
      <StyledSpace size={16}>
        <StyledFormItem noStyle shouldUpdate>
          {(form) => (
            <StyledFormItem name="search">
              <StyledInputSearch
                style={{ width: 'auto' }}
                $customType="filter"
                placeholder={intl.formatMessage({
                  id: 'common.placeholder.search',
                })}
                onSearch={form.submit}
              />
            </StyledFormItem>
          )}
        </StyledFormItem>
        <StyledFormItem name="locale_code">
          <LocalesSelector
            placeholder={intl.formatMessage({
              id: 'common.placeholder.locales',
            })}
            $customType="filter"
          />
        </StyledFormItem>
        <StyledFormItem name="category_id">
          <UserSelector
            placeholder={intl.formatMessage({
              id: 'common.placeholder.categoryName',
            })}
            $customType="filter"
          />
        </StyledFormItem>
      </StyledSpace>
    </FilterForm>
  );
};
